

const About = () =>{
    console.log('about');
}

export default About